<template>
  <form @submit.prevent="onSubmitForm" class="support-options col mt-9 mt-lg-0">
    <div class="mb-5">Chat online</div>

    <form-group
      select
      v-model="chat.status"
      id="select-online-chat"
      label="Status do Chat online"
      :options="[
        { name: 'Ativado', id: 'active' },
        { name: 'Desativado', id: 'inactive' }
      ]"
    />

    <div class="row">
      <div v-if="chat.status === 'active'" class="col-lg-8">
        <div v-for="(item, index) in chatsOptions" :key="index" class="mt-3">
          <purple-button
            v-if="!chat.code || chat.type !== item.type"
            :title="item.title"
            :description="'Clique para integrar.'"
            :image="image(item.type)"
            :disabled="!!chat.code"
            :tooltip="!!chat.code"
            :tooltipContent="'Você já adicionou um Chat.'"
            @action="openConfigChat(item)"
          />

          <box-edit
            v-else
            :title="item.title"
            :description="'Chat ativo'"
            :image="image(item.type)"
            show-remove-button
            :loading-remove="loadingRemove"
            @edit="openConfigChat(item)"
            @remove="removeConfigChat"
          />
        </div>
      </div>
    </div>

    <div class="mt-6">WhatsApp de suporte</div>
    <small class="text-secondary">
      Configure o seu WhatsApp de suporte para o caso do seu pagamento não ser
      aprovado.
    </small>

    <form-group
      select
      class="mt-5"
      id="select-whatsapp-support"
      label="Status do Whatsapp de suporte"
      v-model="form.whatsapp_support.status"
      :options="[
        { name: 'Ativado', id: 'active' },
        { name: 'Desativado', id: 'inactive' }
      ]"
    />

    <div v-if="form.whatsapp_support.status === 'active'">
      <form-group
        class="mt-6"
        v-model="form.whatsapp_support.text"
        id="text"
        label="Mensagem de suporte"
        type="text"
        placeholder="Ex: Preciso de ajuda, houve um problema com o meu pagamento."
        textarea
        rows="2"
      />

      <span class="small-text text-secondary">
        Atenção! Esta mensagem aparecerá caso ocorra algum problema durante o
        pagamento.
      </span>

      <form-group
        class="mt-6"
        v-model="form.whatsapp_support.number"
        id="number"
        label="WhatsApp para suporte"
        placeholder="Número do WhatsApp"
        isPhone
        @country-changed="phoneCountryChanged"
      />
    </div>

    <div class="d-sm-flex d-none justify-content-between mt-9">
      <button
        type="button"
        class="btn btn-outline-secondary d-flex align-items-center"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
      <div class="mx-3"></div>
      <button type="submit" class="btn d-flex align-items-center btn-primary">
        <loading :show="loading">
          Próximo
        </loading>
        <i class="icon-angle-right ml-3" />
      </button>
    </div>
    <div class="d-sm-none justify-content-between mt-9">
      <button
        type="submit"
        class="btn btn-block align-items-center btn-primary"
      >
        <loading :show="loading">
          Próximo
        </loading>
        <i class="icon-angle-right ml-3" />
      </button>
      <div class="m-3"></div>
      <button
        type="button"
        class="btn btn-outline-secondary btn-block align-items-center"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
    </div>

    <modal-form
      :visible="modalVisible"
      @action="submitConfigChat"
      @cancel="modalVisible = false"
      :form="inputsModal"
      :loading="loading"
      :inputsErrors="inputsErrors"
      :title="'Código do Chat.'"
      :description="'Insira o código sem tags (<script>, <iframe>, etc)'"
      :image="image(chat.type)"
    />
  </form>
</template>

<script>
import BoxEdit from "@/components/BoxEdit";
import ModalForm from "@/components/ModalForm";
import PurpleButton from "@/components/PurpleButton";
import get from "lodash/get";

export default {
  components: {
    PurpleButton,
    BoxEdit,
    ModalForm
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    productId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    const chat = this.form.option_support.find(opt => opt.type !== "whatsapp");

    return {
      loading: false,
      loadingRemove: false,
      chat: {
        id: get(chat, "id"),
        code: get(chat, "data.code"),
        type: get(chat, "type"),
        status: get(chat, "status", "inactive")
      },
      modalVisible: false,
      inputsModal: [
        {
          value: get(chat, "data.code"),
          placeholder: "Código do chat",
          id: "code",
          type: "text",
          isTextarea: false,
          index: 0
        }
      ],
      inputsErrors: [{ errors: [] }],
      chatsOptions: [
        {
          title: "Zendesk",
          type: "zendesk",
          placeholder:
            'Parâmetro "key". Ex.: 1275d1d9-38ac-468c-aad4-d877b71705c4'
        },
        {
          title: "Intercom",
          type: "intercom",
          placeholder: "Id do Workspace."
        },
        {
          title: "Crisp",
          type: "crisp",
          placeholder:
            "CRISP_WEBSITE_ID. Ex.: b884e2d5-c9a2-4230-b33f-fd8d2213552e"
        },
        {
          title: "Facebook Chat",
          type: "facebook-chat",
          placeholder: 'Seu "page_id". Ex.: 213392751795255'
        },
        {
          title: "Octadesk Chat",
          type: "octadesk",
          placeholder: "Identificador da empresa. Ex.: Looma"
        },
        {
          title: "JivoSite",
          type: "jivosite",
          placeholder: "Código do widget. Ex.: PfbeXObRSz"
        },
        {
          title: "Tawk.To",
          type: "tawkto",
          placeholder: "Property ID/Widget ID. Ex.: 51ca2b...64fdb/1r4arlpon"
        },
        {
          title: "Zopim",
          type: "zopim",
          placeholder:
            'Parâmetro "key". Ex.: 1275d1d9-38ac-468c-aad4-d877b71705c4'
        },
        {
          title: "Fresh Chat",
          type: "fresh-chat",
          placeholder:
            'Parâmetro "token". Ex.: fv5b58f9-0cbe-410a-r4dc-69iadb7t5d8e'
        },
        {
          title: "Bitrix 24",
          type: "bitrix24",
          placeholder: "Complete: https://cdn.bitrix24.com.br/[...].js"
        }
      ]
    };
  },
  methods: {
    image(type) {
      return type ? require(`@/assets/images/checkout-chat/${type}.png`) : "";
    },
    nextStep() {
      this.$emit("next");
    },
    openConfigChat(item) {
      this.inputsModal[0].placeholder = item.placeholder;
      this.chat.type = item.type;
      this.inputsErrors[0].errors = [];
      this.modalVisible = true;
    },
    removeConfigChat() {
      this.loadingRemove = true;

      this.$store
        .dispatch("optionSupport/delete", this.chat.id)
        .then(() => {
          this.chat.id = null;
          this.chat.type = null;
          this.chat.code = null;
          this.inputsModal[0].value = "";
          this.$emit("remove");
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loadingRemove = false;
        });
    },
    submitConfigChat() {
      if (!this.inputsModal[0].value) {
        this.inputsErrors[0].errors.push("Insira o código");
        return;
      }

      this.loading = true;
      let action = this.chat.id ? "optionSupport/put" : "optionSupport/post";
      this.$store
        .dispatch(action, {
          id: this.chat.id,
          product_id: this.productId,
          type: this.chat.type,
          status: this.chat.status,
          data: {
            code: this.inputsModal[0].value
          }
        })
        .then(response => {
          this.$emit("save", response.data);
          this.chat.id = response.data.id;
          this.chat.code = this.inputsModal[0].value;
          this.inputsErrors[0].errors = [];
          this.modalVisible = false;
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitForm() {
      this.$emit("next");
    },
    phoneCountryChanged(obj) {
      this.form.whatsapp_support.ddi = obj.dialCode;
    }
  }
};
</script>

<style lang="scss" scoped>
.support-options {
  .icon-angle-right,
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }
}
</style>
